import React, { ReactElement, useEffect, useState } from 'react';
import cn from 'classnames';
// @ts-ignore
import { ForceFocus } from '@mo/accessibility';
import './page-title.scss';

export const DEFAULT_TITLE = 'Motability Operations Ltd';

export interface PageTitleProps {
    text: string;
    className?: string;
}

function PageTitle({ text, className }: PageTitleProps): ReactElement {
    const [documentTitle] = useState(document.title);

    useEffect(() => {
        document.title = text;

        return () => {
            document.title = documentTitle;
        };
    }, [document.title, text]);

    return (
        <ForceFocus>
            <h1 className={cn('page-title__title', className)} data-locator='page-title'>
                {text}
            </h1>
        </ForceFocus>
    );
}

export default PageTitle;
